/*
 * These all variables can be overridden by antdVariables.js
 * So antdVariables.js has high precedence
 */
/*
 * Includes antd variables
 * The below default import includes all the antd variables
 * and includes the colorsPalettes as in below link
 * https =//ant.design/docs/spec/colors#BaseColorPalettes
 */

/* CSS Global Variables */

/*
 * The below css global variables can be used accross
 * all the places. .less files and inline style attributes and etc,.
 */

/*
  colors used in the application
*/

// From src/styles/variables.less

export const blue = '#d7e6f7';
export const blue1 = '#0046FF';
export const blue2 = '#e9f3fd';
export const blue3 = '#40a9ff';
export const blue4 = '#e6f7ff';
export const gray1 = '#5e5e5e';
export const gray2 = '#e2e2e2';
export const gray3 = '#f4f6f7';
export const gray4 = '#dadada';
export const green1 = '#90c84f';
export const appBlue = '#215bff';
export const appPanelBgColor = '#ffffff';
export const appTitleColor = '#007882';
export const appBorderColor = '#eaeaea';
export const pageMarginLeftRight = '8px 8px 0 8px';
export const selectedCompareFilterbar = '#f6ccff';
export const mockUpBlue = '#096dd9';
export const warningYellow = '#efc774';
export const activeCardBgColor = '#e9f3fd';
export const activeCardBorderColor = '#82aef0';
export const rootBackgroundColor = '#e9edf0';
// header panel
export const headerContainerHeight = '8px';

// summary panel
export const summaryContainerHeight = '165px';
export const summaryContainerMarginBottom = '2px';

// metrics panel
export const metricsDimensionsPanelTop =
  headerContainerHeight +
  summaryContainerHeight +
  summaryContainerMarginBottom +
  '2px';
export const metricsDimensionsPanelLeftRight = '7px';

// metrics panel
export const metricsPanelWidth = '380px';
export const metricsPanelHeaderHeight = '58px';
export const metricsPanelBodyTop =
  metricsDimensionsPanelTop + metricsPanelHeaderHeight + '2px';
export const metricsPanelMarginRight = '2px';

// all metrics panel
export const allMetricsPanelTop = metricsDimensionsPanelTop;
export const allMetricsPanelLeftRight = metricsDimensionsPanelLeftRight;

// dimensions panel
export const dimContainerLeft =
  metricsDimensionsPanelLeftRight +
  metricsPanelWidth +
  metricsPanelMarginRight +
  '2px';
export const dimContainerHeaderHeight = '60px';
export const dimContainerBodyTop =
  metricsDimensionsPanelTop + dimContainerHeaderHeight + '2px';
export const dimContainerDropdownHeight = '300px';

export const chartHeight = '170px';
export const diagChartTitleHeight = '25px';

// modal background
export const modalmaskBgZIndex = 15; // overlay, to mask the background when filter panel is visible
export const aboveModalBgZIndex = 20; // zIndex used by filter panel dialog so it is above the mask
export const modalmaskLoaderBgZIndex = 1001; // overlay to make entire view when requests are in progress

// used by line charts in metrics and all metrics panels
export const summaryChartCardHeight = '156px';
export const summaryChartHeight = '122px';

export const footerHeight = '30px';

/* Common */
export const widgetX = '20px';
export const widgetY = '20px';
